import { Check } from "lucide-react";

const WhatYoullLearn: React.FC = () => {
  const learnings = [
    "The posting strategy that took me to 3M+ impressions/week",
    "How to write posts that don't flop",
    "How to grow without being verified",
    'The "reply guy" play used by every fast-growing account',
    "My template for viral hooks (≈ 20 examples)",
    // "How I structure threads that get shared",
    "Content categories that ALWAYS perform",
    "How to avoid reach penalties (links, app names, etc.)",
    // "The exact weekly posting schedule I follow",
    "Real screenshots: analytics, virals, content ideas",
    "My full workflow to write 7 days of content in 60 minutes",
    "A bonus: how I recovered a hacked account… and grew 10k followers after it"
  ];

  return (
    <section className="bg-black text-white py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">
          What you'll learn
        </h2>
        
        <p className="text-xl text-cyan-400 font-semibold mb-8 text-center">
          A system you can copy right away:
        </p>
        
        <div className="grid md:grid-cols-2 gap-4 mb-8">
          {learnings.map((item, index) => (
            <div key={index} className="flex items-start space-x-3 bg-gray-900 p-4 rounded-lg">
              <Check className="text-cyan-400 flex-shrink-0 mt-1" size={20} />
              <span className="text-gray-200">{item}</span>
            </div>
          ))}
        </div>
        
        <p className="text-center text-lg text-gray-300 font-medium">
          Everything inside is actionable. No fluff. No theory. Just what actually works today.
        </p>
      </div>
    </section>
  );
};

export default WhatYoullLearn;